module.exports = __webpack_public_path__ + "img/ic_country_serve_img6.da3e53f1.png";